import { FC, memo } from 'react'

export type TileImageProps = {
  url?: string
  className?: string
  errorPlaceholder?: string
}

const TileImageRaw: FC<TileImageProps> = ({
  url = '',
  className = '',
  errorPlaceholder = '',
}) => {
  const onError = (currentTarget: EventTarget & HTMLImageElement) => {
    currentTarget.onerror = null
    currentTarget.src = errorPlaceholder
  }

  return (
    <>
      <img
        src={url}
        alt=""
        className={className}
        onError={(e) => errorPlaceholder && onError(e.currentTarget)}
      />
    </>
  )
}

export const TileImage = memo(TileImageRaw)
